import axios from 'axios'
import store from '../store/index'

import { Toast } from "vant"

//访问根路径

let baseUrl = window.location.origin

if(process.env.NODE_ENV === 'production') {
  
}

const service = axios.create({
  baseURL: baseUrl,
  timeout: 5000
})

// request拦截器
service.interceptors.request.use(config => {
  Toast.loading({
    forbidClick: true,
    loadingType: 'spinner',
  });   
  return config
}, error => {
  Promise.reject(error)
})

// response拦截器
service.interceptors.response.use(
  response => {
    Toast.clear();
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
) 

export default service